import { render, staticRenderFns } from "./v-footer.vue?vue&type=template&id=d106abd4&"
import script from "./v-footer.vue?vue&type=script&lang=js&"
export * from "./v-footer.vue?vue&type=script&lang=js&"
import style0 from "./v-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports